import { Link } from 'react-router';
import './AdminListHeader.css';

export interface AdminListHeaderPrimaryAction {
  label: string;
  to?: string;
  onClick?: () => void;
}

export interface AdminListHeaderProps {
  title: string;
  count: number;
  primaryAction: AdminListHeaderPrimaryAction;
}

export function AdminListHeader({ title, count, primaryAction }: AdminListHeaderProps) {
  const showCta = count > 0;
  return (
    <header className="admin-list-header">
      <div className="admin-list-header__title-row">
        <h1 className="admin-list-header__title">{title}</h1>
        {count > 0 && (
          <span
            className="admin-list-header__count"
            aria-label={`${count} ${count === 1 ? 'item' : 'items'}`}
          >
            {count}
          </span>
        )}
      </div>
      {showCta && (primaryAction.to ? (
        <Link to={primaryAction.to} className="rb-btn rb-btn-save">{primaryAction.label}</Link>
      ) : (
        <button type="button" className="rb-btn rb-btn-save" onClick={primaryAction.onClick}>{primaryAction.label}</button>
      ))}
    </header>
  );
}
